import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setLoading } from '../../redux/actions/loader.action';
import { getProducts } from '../../redux/actions/product.action';
import { logout } from '../../redux/actions/auth.action';
import { endpoint, endpointApi } from '../../utils';
import axios from 'axios';
import Paginate from '../../components/Paginate';
import SearchCategory from '../../components/SearchCategory';
import QuillEditor from '../../components/QuillEditor';

export default function ProductsPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const products = useSelector(state => state.products);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { me } = useSelector(state => state.auth);

    const modalRef = useRef(null);
    const fileRef = useRef(null);
    const detailsModalRef = useRef(null);
    const [product, setProduct] = useState(null);
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);

    const [code, setCode] = useState("");
    const [photo, setPhoto] = useState("");
    const [name, setName] = useState("");
    const [category, setCategory] = useState(null);
    const [subtitle, setSubtitle] = useState("");
    const [description, setDescription] = useState("");
    const [safetyStockLevel, setSafetyStockLevel] = useState("");
    const [quantity, setQuantity] = useState("");
    const [unit, setUnit] = useState("");
    const [unitLabel, setUnitLabel] = useState("");
    const [price, setPrice] = useState("");
    const [status, setStatus] = useState("");

    const [isCodeTouched, setIsCodeTouched] = useState(false);
    const [isNameTouched, setIsNameTouched] = useState(false);
    const [isSubtitleTouched, setIsSubtitleTouched] = useState("");
    const [isSafetyStockLevelTouched, setIsSafetyStockLevelTouched] = useState(false);
    const [isQuantityTouched, setIsQuantityTouched] = useState(false);
    const [isPriceTouched, setIsPriceTouched] = useState(false);
    const [isStatusTouched, setIsStatusTouched] = useState("");
    const [isUnitLabelTouched, setIsUnitLabelTouched] = useState(false);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getProducts(location, navigate));
    }, [location, dispatch, navigate]);

    const handlePhotoChange = (e) => {
        const selectedPhoto = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result;
            setPhoto(base64String);
        };
    
        if (selectedPhoto) {
            reader.readAsDataURL(selectedPhoto);
        }
    }

    useEffect(() => {
        const clickOutsideModal = (e) => {
            if((modalRef.current === e.target && e.target.classList.contains('active')) || (detailsModalRef.current === e.target && e.target.classList.contains('active')) || e.target.classList.contains('_modal-close')){
                setModal(null);
            }
        }
        document.addEventListener('click', clickOutsideModal);
        return () => {
            document.removeEventListener('click', clickOutsideModal);
        }
    }, []);

    useEffect(() => {
        if(modal !== 'update'){
            if(modal !== 'details')
                setProduct(null);

            setCode("");
            setPhoto("");
            setName("");
            setCategory(null);
            setSubtitle("");
            setDescription("");
            setSafetyStockLevel("");
            setQuantity("");
            setUnit("");
            setUnitLabel("");
            setPrice("");
            setStatus("");

            setIsCodeTouched(false);
            setIsNameTouched(false);
            setIsSubtitleTouched(false);
            setIsSafetyStockLevelTouched(false);
            setIsQuantityTouched(false);
            setIsPriceTouched(false);
            setIsUnitLabelTouched(false);
            setIsStatusTouched(false);

            setErrors(null);
            if(fileRef.current)
                fileRef.current.value = null;
        }
    }, [modal]);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);

    useEffect(() => {
        if(product){
            setCode(product.code ? product.code : "");
            setPhoto("");
            setName(product.name ? product.name : "");
            setCategory(product.category);
            setSubtitle(product.subtitle ? product.subtitle : "");
            setDescription(product.description ? product.description : "");
            setQuantity(product.quantity);
            setSafetyStockLevel(product.safety_stock_level);
            setUnit(product.unit ? product.unit : "");
            setUnitLabel(product.unit_label ? product.unit_label : "");
            setPrice(product.price ? product.price : "");
            setStatus(product.status);
        }
    }, [product]);

    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        if(modal === "add"){
            await axios.post(`${ endpointApi }products`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${ jwt_access }`
                }
            }).then(({ data }) => {
                dispatch(getProducts(location, navigate));
                setProduct(data);
                setModal("details");
                setPhoto("");
                if(fileRef.current)
                    fileRef.current.value = null;
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }else{
            await axios.post(`${ endpointApi }products/${ product.id }`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${ jwt_access }`
                }
            }).then(({ data }) => {
                dispatch(getProducts(location, navigate));
                setProduct(data);
                setModal("details");
                setPhoto("");
                if(fileRef.current)
                    fileRef.current.value = null;
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }
    }

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Produits - Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Produits</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div ref={ modalRef } className={ `_modal${ modal === 'add' || (modal === 'update' && product) ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>{ modal === 'add' ? 'Ajouter' : 'Modifier' } un produit</h4>
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                { modal === "update" && 
                                <div className='pb-3'>
                                    <label htmlFor='code' className='required'>Code</label>
                                    <input type='text' id='code' name='code' placeholder='Code' autoComplete='off' className='form-control' required value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code produit.</div> }
                                    { isCodeTouched && code.length > 0 && /^PEC\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Désolé, ce code n'est pas valide. Le format valide est: PEC/[année]/[numéro d'ordre].</div> }
                                    { errors && errors.code && <div className='form-error'>{ errors.code[0] }</div> }
                                </div> }
                                <div className='pb-3'>
                                    <label htmlFor='name' className='required'>Nom du produit</label>
                                    <input type='text' id='name' name='name' placeholder='Nom du produit' autoComplete='off' className='form-control' required value={ name } onChange={ (e) => setName(e.target.value) } onBlur={ () => setIsNameTouched(true) } />
                                    { isNameTouched && name.length === 0 && <div className='form-error'>Veuillez saisir le nom du produit.</div> }
                                    { isNameTouched && name.length > 0 && name.length < 2 && <div className='form-error'>Le nom du produit est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.name && <div className='form-error'>{ errors.name[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='category_id' className='required'>Catégorie</label>
                                    <input type='hidden' name='category_id' className='form-control' value={ category ? category.id : "" } />
                                    <SearchCategory updateCategory={ setCategory } defaultValue={ category } />
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='subtitle'>Sous-titre</label>
                                    <textarea id='subtitle' maxLength={ 255 } name='subtitle' placeholder='Sous-titre' className='form-control' value={ subtitle } onChange={ (e) => setSubtitle(e.target.value) } onBlur={ () => setIsSubtitleTouched(true) }></textarea>
                                    { isSubtitleTouched && subtitle.length === 0 && <div className='form-error'>Veuillez saisir le sous-titre.</div> }
                                    { isSubtitleTouched && subtitle.length > 0 && subtitle.length < 2 && <div className='form-error'>Le sous-titre est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.subtitle && <div className='form-error'>{ errors.subtitle[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='description' className='required'>Description</label>
                                    <QuillEditor onChange={ setDescription } defaultValue={ description } placeholder='Description' />
                                    <textarea style={{ display: 'none' }} name='description' value={ description } onChange={ (e) => setDescription(e.target.value) }></textarea>
                                    { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='photo' className='required'>Photo</label><br/>
                                    <input ref={ fileRef } type='file' name="photo" id="photo" required={ modal === 'add' } accept='.png,.jpeg,.jpg' onChange={ handlePhotoChange } />
                                    { (photo.length > 0 || (product && product.photo)) && <div className='pt-2'>
                                        <div className='photo'>
                                            <img src={ photo.length ? photo : endpoint + 'storage/' + product.photo } alt="" />
                                        </div>
                                    </div> }
                                    { errors && errors.photo && <div className='form-error'>{ errors.photo[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='quantity' className='required'>Quantité</label>
                                    <input type='number' id='quantity' min={ 0 } step={ 1 } name='quantity' placeholder='Quantité' autoComplete='off' className='form-control' required value={ quantity } onChange={ (e) => setQuantity(e.target.value) } onBlur={ () => setIsQuantityTouched(true) } />
                                    { isQuantityTouched && quantity.length === 0 && <div className='form-error'>Veuillez saisir la quantité.</div> }
                                    { errors && errors.quantity && <div className='form-error'>{ errors.quantity[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='unit'>Unité</label>
                                    <select id='unit' name='unit' className='form-control' value={ unit } onChange={ (e) => setUnit(e.target.value) } >
                                        <option value="">Sélectionner...</option>
                                        <option value="Item">Pièce</option>
                                        <option value="Box">Boîte</option>
                                        {/*
                                        <option value="Carton">Carton</option>
                                        */}
                                    </select>
                                    { errors && errors.unit && <div className='form-error'>{ errors.unit[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='unit_label' className='required'>Ex: Rambo, Bambou, Style, etc...</label>
                                    <select id='unit_label' name='unit_label' required className='form-control' value={ unitLabel } onChange={ (e) => setUnitLabel(e.target.value) } onBlur={ () => setIsUnitLabelTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="RAMBO">Rambo</option>
                                        <option value="BAMBOU">Bambou</option>
                                        <option value="PEN">Stylos</option>
                                        <option value="TOOTHBRUSH">Brosse à dents</option>
                                    </select>
                                    { isUnitLabelTouched && unitLabel.length === 0 && <div className='form-error'>Veuillez sélectionner le nom de l'unité.</div> }
                                    { errors && errors.unit_label && <div className='form-error'>{ errors.unit_label[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='safetyStockLevel' className='required'>Stock de sécurité</label>
                                    <input type='number' id='safetyStockLevel' min={ 0 } step={ 1 } name='safety_stock_level' placeholder='Stock de sécurité' autoComplete='off' className='form-control' required value={ safetyStockLevel } onChange={ (e) => setSafetyStockLevel(e.target.value) } onBlur={ () => setIsSafetyStockLevelTouched(true) } />
                                    { isSafetyStockLevelTouched && safetyStockLevel.length === 0 && <div className='form-error'>Veuillez saisir le stock de sécurité.</div> }
                                    { errors && errors.safety_stock_level && <div className='form-error'>{ errors.safety_stock_level[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='price' className='required'>Prix en Ariary</label>
                                    <input type='number' id='price' min={ 0 } step={ 0.01 } name='price' placeholder='Prix en Ariary' autoComplete='off' className='form-control' required value={ price } onChange={ (e) => setPrice(e.target.value) } onBlur={ () => setIsPriceTouched(true) } />
                                    { isPriceTouched && price.length === 0 && <div className='form-error'>Veuillez saisir le prix.</div> }
                                    { errors && errors.price && <div className='form-error'>{ errors.price[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='status' className='required'>Statut</label>
                                    <select id="status" name='status' className='form-control' value={ status } required onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                                        <option value="">Sélectionner</option>
                                        <option value="1">Publié</option>
                                        <option value="0">Non publié</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez Sélectionner le statut.</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled= {
                                        name.length < 0 || description.length < 30 || safetyStockLevel.length === 0 || quantity.length === 0 || unit.length === 0 ||
                                        (product && modal !== 'add' && status === product.status && name === product.name && description === product.description && safetyStockLevel === product.safety_stock_level && quantity === product.quantity && unit === product.unit)
                                    }>{ modal === 'add' ? <><i className="fa fa-save"></i> Enregistrer</> : <><i className="fa fa-save"></i> Mettre à jour</> }</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && product ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { product && 
                            <h4>{ product.code + " - " + product.name }</h4> }
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { product && <>
                            <div className='mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ product.code }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Nom du produit</div>
                                <div className='_value'>{ product.name }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Catégorie</div>
                                <div className='_value'>{ product?.category?.name }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Sous-titre</div>
                                <div className='_value'>{ product.subtitle ? product.subtitle : '-' }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Description</div>
                                <div className='_value' dangerouslySetInnerHTML={{ __html: product.description ? product.description : '-' }}></div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Photo</div>
                                <div className='_value'>
                                    <div className='photo'>
                                        { product.photo &&
                                        <img src={ endpoint + 'storage/' + product.photo } alt="" /> }
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Quantité</div>
                                <div className='_value'>{ product.quantity }{ product.unit ? ' ' + (product.unit === 'Item' ? 'pièce' : (product.unit === 'Box' ? 'boîte' : 'carton')) + (product.quantity > 1 ? 's' : '') : '' }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Stock de sécurité</div>
                                <div className='_value'>{ product.safety_stock_level }{ product.unit ? ' ' + (product.unit === 'Item' ? 'pièce' : (product.unit === 'Box' ? 'boîte' : 'carton')) + (product.quantity > 1 ? 's' : '') : '' }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Prix</div>
                                <div className='_value'>{ product.price ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(product.price) + ' Ariary' : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Etat</div>
                                <div className='_value'>{ product.safety_stock_level > 0 ? (product.quantity <= product.safety_stock_level ? <span className='badge bg-danger'>En rupture de stock</span> : <span className='badge bg-success'>En stock</span>) : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Statut</div>
                                <div className='_value'>{ parseInt(product.status) === 1 ? <span className='badge bg-success'>Publié</span> : <span className='badge bg-danger'>Non publié</span> }</div>
                            </div>
                            <div className='pt-2 text-end'>
                                <button type='button' className='btn btn-lg btn-primary' onClick={ () => {
                                    setModal("update");
                                } }><i className='fa fa-edit'></i> Modifier</button>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                        <tr>
                            <th width="100">Code</th>
                            <th>Nom du produit</th>
                            <th className='text-center'>Stock de sécurité</th>
                            <th>Quantité</th>
                            <th>Etat</th>
                            <th>Statut</th>
                            <th width="75" className="text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        { products.loading && <tr><td colSpan={ 7 }>Chargement...</td></tr> }
                        { products.loading === false && products.data && products.data.total === 0 && <tr><td colSpan={ 7 }>Aucun élément trouvé</td></tr> }
                        { products.loading === false && products.data && products.data.data && products.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>{ item.code }</td>
                                <td>{ item.name }</td>
                                <td className='text-center'>{ item.safety_stock_level }</td>
                                <td>{ item.quantity }{ item.unit ? ' ' + (item.unit === 'Item' ? 'pièce' : (item.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                                <td>{ item.safety_stock_level > 0 ? (item.quantity <= item.safety_stock_level ? <span className='badge bg-danger'>En rupture de stock</span> : <span className='badge bg-success'>En stock</span>) : "-" }</td>
                                <td>{ parseInt(item.status) === 1 ? <span className='badge bg-success'>Publié</span> : <span className='badge bg-danger'>Non publié</span> }</td>
                                <td className="text-end">
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                            e.stopPropagation();
                                            setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setProduct(item);
                                                setModal("details");
                                            } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setProduct(item);
                                                setModal("update");
                                            } }><i className="fa fa-edit"></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>
                
                { products && products.data &&
                <Paginate currentPage={ products.data.current_page } totalPages={ products.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
